import { CardElement } from "@stripe/react-stripe-js"
import { FC, useContext, useEffect, useState } from "react"
import { UserContext } from "../../context"
import { isAdmin } from "../../utils/userUtils"

export const StripeForm: FC = () => {
  const [globalFontSize, setGlobalFontSize] = useState<number>(16)
  const user = useContext(UserContext)
  useEffect(() => {
    // consolelog('change font size',)
    if (isAdmin(user.user)) {
      setGlobalFontSize(16) //should change to 14 when ready
    } else {
      setGlobalFontSize(18)
    }
  }, [user.user?.userRole,user.user])
 

  return (
    <div style={{width:'100%'}}>
    <div style={{maxWidth:'32em'}} >
      <div style={{marginBottom:'1em',color:'gray',fontStyle:'italic'}}>Please enter credit card information below: </div>
      <CardElement
      options={{
        style: {
          base: {
            color: '#32325d',
            fontFamily: 'Arial, sans-serif',
            fontSize: globalFontSize+'px',
            '::placeholder': { color: '#aab7c4' },
          },
          invalid: { color: '#fa755a' },
        },
      }} />
    
    
    </div>
    </div>
  )
}
